var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25438 12.6586C-0.430985 14.4689 -0.416172 17.368 1.2876 19.1592C2.99137 20.9503 5.74912 20.9659 7.4711 19.1941L18.1909 7.92455C19.3214 6.76136 19.7703 5.04936 19.3663 3.44153C18.9624 1.8337 17.7679 0.577984 16.2385 0.153333C14.7091 -0.271319 13.0807 0.200579 11.9742 1.38903L1.25438 12.6586Z",
    fill: "url(#paint0_linear_4368_41418)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8144 24.041C4.67936 25.2093 4.22867 26.9287 4.63423 28.5435C5.0398 30.1583 6.23908 31.4195 7.77465 31.846C9.31021 32.2725 10.9453 31.7985 12.0562 30.6049L22.8213 19.2864C24.4353 17.4577 24.3858 14.6143 22.7093 12.8489C21.0327 11.0835 18.3289 11.0276 16.5878 12.7225L5.8144 24.041Z",
    fill: "url(#paint1_linear_4368_41418)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40467 11.2821C1.97204 11.2821 2.29368e-08 13.3484 2.29368e-08 15.8974C2.29368e-08 18.4464 1.97204 20.5128 4.40467 20.5128H19.5953C22.028 20.5128 24 18.4464 24 15.8974C24 13.3484 22.028 11.2821 19.5953 11.2821H4.40467Z",
    fill: "url(#paint2_linear_4368_41418)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4368_41418",
    x1: 11.9603,
    y1: 43.8388,
    x2: 38.627,
    y2: 23.8388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#236EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#13A6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#05D6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4368_41418",
    x1: 12.0955,
    y1: 43.7734,
    x2: 38.8698,
    y2: 23.6865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5032C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#4C44C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4175B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2FC1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#28E1A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4368_41418",
    x1: 0,
    y1: 20.5124,
    x2: 23.9979,
    y2: 20.5124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0096DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0BABCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#18C3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21D4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#26DEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E1A0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMp);
export default __webpack_public_path__ + "static/media/logo_MP.f7bb5b454c89e102b95b1573ca4663e5.svg";
export { ForwardRef as ReactComponent };